import { useCallback, useEffect } from 'react';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useTranslation } from '@frontend/i18n';
import { useAlert } from '@frontend/design-system';
import { useCombinedScheduleRequest } from '../hooks/use-combined-requests';
import { useGetScheduleRequestInfiniteListQuery } from '../hooks/useGetScheduleRequestInfiniteListQuery';

export const useSchedulePulseRequestList = ({ locationId }: { locationId: string }) => {
  const { t } = useTranslation('scheduleCalendarActions');

  const alert = useAlert();
  const { isScheduleV3FlagEnabled } = SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();
  const combinedBookingListQuery = useCombinedScheduleRequest(locationId);
  const scheduleRequestListQuery = useGetScheduleRequestInfiniteListQuery(locationId);
  const combineBookingRequestsRefetch = combinedBookingListQuery.refetchQueries;
  const scheduleRequestListRefetch = scheduleRequestListQuery.refetch;
  const refetchScheduleRequestList = useCallback(
    () => (isScheduleV3FlagEnabled ? combineBookingRequestsRefetch() : scheduleRequestListRefetch()),
    [isScheduleV3FlagEnabled, combineBookingRequestsRefetch, scheduleRequestListRefetch]
  );

  useEffect(() => {
    if (scheduleRequestListQuery.isError) {
      alert.error(t('Failed to load appointment request list'));
    }
  }, [alert, scheduleRequestListQuery.isError, t]);

  const isEmptyScheduleRequestList = isScheduleV3FlagEnabled
    ? combinedBookingListQuery?.data?.pages?.[0]?.rows?.length
    : !scheduleRequestListQuery?.data?.pages?.[0]?.rows?.length;

  const infiniteListQuery = isScheduleV3FlagEnabled ? combinedBookingListQuery : scheduleRequestListQuery;

  return { refetchScheduleRequestList, isEmptyScheduleRequestList, infiniteListQuery };
};
